import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { GrocySuccess } from '../../entities/grocy/shared/success.entity';
import { GrocyCurrentStock } from '../../entities/grocy/stock/current-stock.entity';
import { BaseApi } from '../base.api';

@Injectable({
  providedIn: 'root',
})
export class GrocyStockApi extends BaseApi {
  endpoint = 'grocy/stock';

  findCurrent(): Observable<GrocyCurrentStock[]> {
    return this.http.get<GrocyCurrentStock[]>(this.generateUrl('current')).pipe(catchError(e => this.handleError(e)));
  }

  undoTransaction(transactionId: string): Observable<GrocySuccess> {
    return this.http
      .delete<GrocySuccess>(this.generateUrl(`transactions/${transactionId}`), {})
      .pipe(catchError(e => this.handleError(e)));
  }
}
